export default "__VITE_ASSET__B5Zc$rKP__"